import { gql, type DocumentNode } from "@apollo/client";

import { type RunState } from "types/generated";

export type RunToPoll = {
  stackId: string;
  runId: string;
};

type BulkRunStateData = {
  run: {
    id: string;
    state: RunState;
    // used by shouldPoll to stop polling when all runs are finished
    finished: boolean;
  } | null;
};

export type StacksBulkActionsResultsTriggeredRunsData = Record<string, BulkRunStateData>;

const queryCache = new Map<string, DocumentNode>();

// Placeholder query used when there are no runs to poll (Apollo requires a valid DocumentNode even when skipped)
const PLACEHOLDER_QUERY = gql`
  query PollBulkActionRunStatesPlaceholder {
    __typename
  }
`;

export const buildBulkRunStatesQuery = (runs: RunToPoll[]): DocumentNode => {
  if (runs.length === 0) {
    return PLACEHOLDER_QUERY;
  }

  const key = runs.map((r) => `${r.stackId}:${r.runId}`).join(",");

  const cached = queryCache.get(key);
  if (cached) {
    return cached;
  }

  const fields = runs
    .map(
      (run, i) => `
    stack_${i}: stack(id: "${run.stackId}") {
      run(id: "${run.runId}") {
        id
        state
        finished
      }
    }
  `
    )
    .join("\n");

  const query = gql`query PollBulkActionRunStates { ${fields} }`;
  queryCache.set(key, query);

  return query;
};
